import React, { useEffect, useMemo, useState } from 'react';
import { messages } from "../../../../../../../../messages.js";
import { config } from "../../../../../../../../config";
import close from "../../../../../../../../assets/close.svg";
import { maskingToPlainNumber, phoneNumberMask, ShirtSize, validateEmail } from '../../../../../../../../Util/helper';
import axiosApi from '../../../../../../../../core/interceptor/interceptor';
import dropdown from "../../../../../../../../assets/dropdown.svg";
import { useHistory } from "react-router-dom";
import _ from 'lodash';
import NumberFormat from 'react-number-format';
import { LoaderMini } from '../../../../../../../../Util/Loader.js';
import CustomSelect from '../../../../../../../../Util/CustomSelect/CustomSelect.js';

export default function AddPlayerModel(props) {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [emailExist, setEmailExist] = useState(false);
  /***** States of form ******/
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    cell_phone: '',
    secondary_phone: '',
    shirt_size: null,
    team_id: props.teamId,
    is_captain: false,
  });
  const history = useHistory();
  const leagueId = props.leagueId;
  const teamId = props.teamId;
  const [shirtSizeList, setShirtSizeList] = useState([]);
  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    cellPhone: '',
    secondaryPhone: '',
    shirt_size: '',
  });
  const [messageDropEnable, setMessageDropEnable] = useState(false);
  const enableMesgDrop = () => {
    setMessageDropEnable(!messageDropEnable);
  }
  const debouncedCheckEmailExistance = useMemo(
    () => _.debounce((email, id) => checkEmail(email, id), 1500),
    [],
  );

  const [checkingEmail, setCheckingEmail] = useState(false);

  const checkEmail = (email) => {
    setCheckingEmail(true);
    axiosApi.post(`${config.apiUrl}/misc/check-email-existance`, { email })
      .then((res) => {
        setEmailExist(!!res.data.data);
        setCheckingEmail(false);
      })
      .catch((err) => {
        console.error(err);
        setCheckingEmail(false);
      });
  }

  /***** Triggers when form data changes ******/
  const handleFormChange = (event) => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      [event.target.name]: event.target.value,
    }))
  }

  /**** Triggers when form submit *****/
  const handleSubmit = (event) => {
    event.preventDefault();
    setFormSubmitted(true);
    const data = formData;
    data['cell_phone'] = maskingToPlainNumber(data.cell_phone);
    data['secondary_phone'] = maskingToPlainNumber(data.secondary_phone);
    data.email = data.email.trim();
    if (handleValidation()) {
      axiosApi.post(`${config.apiUrl}/teams/player`, formData)
        .then((res) => {
          setFormSubmitted(false);
          closeModal();
          if (props.fromLeague) {
            history.push(`/admin/leagues/LeagueGroups/TeamInfo/${leagueId}/${teamId}${props.seasonId ? `?season_id=${props.seasonId}` : ''}`);
          } else {
            history.push(`/admin/leagues/individual-registrations/TeamInfo/ ${leagueId}/${teamId}`);
          }
        })
    }
  }

  const setStatus = (val) => {
    setFormData((previousFormData) => ({
      ...previousFormData,
      'shirt_size': val,
    }))
  }

  useEffect(() => {
    let list = [];
    Object.keys(ShirtSize).forEach(val => list.push(<li onClick={() => { setMessageDropEnable(o => !o); setStatus(val); }} key={val}>{ShirtSize[val]}</li>));
    setShirtSizeList(list);
  }, [])

  /*** closes modal *****/
  const closeModal = () => {
    props.closeModal();
  }

  const handleValidation = () => {
    let errorArr = {};
    let formIsValid = true;

    /***** name validation ******/
    if (!formData['first_name']) {
      formIsValid = false;
      errorArr["firstName"] = messages.emptyName;
    }

    if (!formData['last_name']) {
      formIsValid = false;
      errorArr["lastName"] = messages.emptyLastName;
    }

    /***** email validation ******/
    if (!formData['email']) {
      formIsValid = false;
      errorArr["email"] = messages.emptyEmail;
    } else if (typeof formData['email'] !== "undefined") {
      if (!validateEmail((formData.email).trim())) {
        formIsValid = false;
        errorArr["email"] = messages.invalidEmail;
      } else {
        if (emailExist) {
          formIsValid = false;
          errorArr["email"] = messages.email_taken;
        }
      }
    }
    if (formData.cell_phone && formData.cell_phone.replace(/\D/g, '').length < 10) {
      formIsValid = false;
      errorArr['cellPhone'] = messages && messages.phoneLength;
    }
    if (formData.secondary_phone && formData.secondary_phone.replace(/\D/g, '').length < 10) {
      formIsValid = false;
      errorArr['secondaryPhone'] = messages && messages.phoneLength;
    }

    setErrors(errorArr);
    return formIsValid;
  }

  useEffect(() => {
    if (validateEmail(formData.email.trim())) {
      debouncedCheckEmailExistance(formData.email.trim());
    }
    //eslint-disable-next-line
  }, [formData.email]);

  useEffect(() => {
    handleValidation();
    //eslint-disable-next-line
  }, [
    formData.first_name,
    formData.last_name,
    formData.email,
    formData.shirt_size,
    formData.cell_phone,
    formData.secondary_phone,
    emailExist,
  ]);
  return <>
    <div className="modal add-player-modal">
      <div className="modal-header">
        <h2>Manually Add Player</h2>
        <p>Add Player to "{props.teamName}"</p>
        <span className="close" onClick={closeModal}>
          <img src={close} alt='close-icon' />
        </span>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="add-adminModal">
          <div className="input-field">
            <label>First Name<sup>*</sup></label>
            <input type="text" name="first_name" value={formData.first_name} onChange={handleFormChange} />
            {formSubmitted && <span className="error">{errors["firstName"]}</span>}
          </div>
          <div className="input-field">
            <label>Last Name<sup>*</sup></label>
            <input type="text" name="last_name" value={formData.last_name} onChange={handleFormChange} />
            {formSubmitted && <span className="error">{errors["lastName"]}</span>}
          </div>
          <div className="input-field input-field-email">
            <label>Email<sup>*</sup></label>
            <div className="email-spinner-wrapper">
              <input type="text" name="email" value={formData.email} onChange={handleFormChange} />
              {checkingEmail && <div className="spinner"><LoaderMini /></div>}
            </div>
            {(formSubmitted || (messages.email_taken === errors["email"])) && <span className="error">{errors["email"]}</span>}
          </div>
          <div className="input-field">
            <label>Primary Phone</label>
            <NumberFormat format={phoneNumberMask} mask="_" name="cell_phone" value={formData.cell_phone} onChange={handleFormChange} />
            {formSubmitted && <span className="error">{errors["cellPhone"]}</span>}
          </div>
          <div className="input-field">
            <label>Secondary Phone</label>
            <NumberFormat format={phoneNumberMask} mask="_" name="secondary_phone" value={formData.secondary_phone} onChange={handleFormChange} />
            {formSubmitted && <span className="error">{errors["secondaryPhone"]}</span>}
          </div>
          <div className="input-field">
            <label>Shirt Size</label>
            <div className="dropdown-blk2">
              <div className="dropdown-header" onClick={() => enableMesgDrop()}>
                <span>{formData && formData.shirt_size ? ShirtSize[formData.shirt_size] : 'Select Shirt Size'}</span>
                <div className="arrow-blk">
                  <img src={dropdown} alt="dropdown" />
                </div>
              </div>
              <ul className={`${messageDropEnable && 'active'} dropdown-menu`}>
                {shirtSizeList}
              </ul>
            </div>
            {formSubmitted && <span className="error">{errors["shirt_size"]}</span>}
          </div>
          <div>
            <CustomSelect
              data={[{id: true, name: 'Yes'}, {id: false, name: 'No'}]}
              label={'Promote to captain'}
              placeholder={formData.is_captain ? 'Yes' : 'No'}
              onSelect={(e) => e && handleFormChange({
                target: {
                  name: 'is_captain',
                  value: e.id
                }
              })}
              selector="name"
            />
          </div>
        </div>
        <div className="modal-footer d-flex">
          <button className="cancel-btn" onClick={closeModal}>Cancel</button>
          <button type="submit">Confirm</button>
        </div>
      </form>
    </div>
  </>
}